import styled from 'styled-components'

const MenuItemUi = styled.div`
  display: flex;
  padding: 20px 20px 0;
`

export default MenuItemUi
